import service from "@/tools/request";
import defaultRequestErrorHandle from "@/plug/request/defaultErrorHandle";

export function institutionLocation({
  longitude,
  latitude
}) {
  return service({
    url: '/institutionLocation',
    method: 'post',
    data: {
      longitude,
      latitude
    }
  }).catch(defaultRequestErrorHandle)
}

export function patientList({
  phone,
  institution_id
}) {
  return service({
    url: '/patientList',
    method: 'post',
    data: {
      phone,
      institution_id
    }
  }).catch(defaultRequestErrorHandle)
}

export function getInsName({
  institution_id
}) {
  return service({
    url: '/getInsName',
    method: 'post',
    data: {
      institution_id
    }
  }).catch(defaultRequestErrorHandle)
}

export function fuzzyReportInfo({
  name,
  exam_datetime,
  phone,
  institution_id
}) {
  return service({
    url: '/fuzzyReportInfo',
    method: 'post',
    data: {
      name,
      exam_datetime,
      phone,
      institution_id
    }
  }).catch(defaultRequestErrorHandle)
}

export function institutionNameSearch({
  search
}) {
  return service({
    url: '/institutionNameSearch',
    method: 'post',
    data: {
      search
    }
  }).catch(defaultRequestErrorHandle)
}
export function institutionListLocation({
  longitude,
  latitude
}) {
  return service({
    url: '/institutionListLocation',
    method: 'post',
    data: {
      longitude,
      latitude
    }
  }).catch(defaultRequestErrorHandle)
}

export function getReportByBarCode({
  bar_code,
  institution_id,
  phone
}) {
  return service({
    url: '/getReportByBarCode',
    method: 'post',
    data: {
      bar_code,
      institution_id,
      phone
    }
  }).catch(defaultRequestErrorHandle)
}